export enum SignTypeSources {
  web = 'Веб-интерфейс',
  onecvk = '1С',
  public = 'API',
}
